import React, { Component } from "react";
import {
  Progress,
  Divider,
  Modal,
  Input,
  TreeSelect,
  Radio,
  Button,
} from "antd";
import "./audio.css";
const { SHOW_PARENT, TreeNode } = TreeSelect;
const { TextArea } = Input;

export default class AudioEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      radioValue: 1,
      title: this.props.title,
      value2: this.props.desc,
      value3: this.props.labelNames,
      value4: "单位发布",
      accountKey: "",
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  componentDidMount() { }

  render() {
    const treeData = JSON.parse(
      JSON.stringify(this.props.filterColumn)
        .replace(/name/g, "title")
        // .replace(/sons/g, "children")
        .replace(/id/g, "value")
    );
    const treeData3 = JSON.parse(
      JSON.stringify(this.props.userDate)
        .replace(/name/g, "title")
        // .replace(/sons/g, "children")
        .replace(/id/g, "value")
    );
    return (
      <div>
        <Modal
          title="编辑视频"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width="1122px"
          bodyStyle={{ height: "850px" }}
          footer={null}
        >
          <div className="imgPublic">
            <h1>视频发布</h1>
          </div>

          <div
            style={{
              width: "870px",
              height: "100px",
              backgroundColor: "#fafafa",
              margin: "20px 110px",
              padding: "0px 10px",
            }}
          >
            <div style={{ paddingTop: "10px" }}>{this.props.VideoName}</div>
            <div style={{ marginTop: "10px" }}>
              <Progress percent={100} strokeColor="#1e9fff" showInfo={false} />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "5px",
                color: "#1e9fff",
              }}
            >
              <span>视频编辑</span>
              <span style={{ marginLeft: "20px" }}>重新上传</span>
            </div>
          </div>
          <Divider />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "30px",
              marginLeft: "30px",
            }}
          >
            <div>*</div>
            <div
              style={{
                margin: "0 20px 0 0",
                width: "40px",
                textAlign: "center",
              }}
            >
              标题
            </div>

            <Input value={this.state.title} style={{ marginLeft: "5px" }} />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "30px",
              marginLeft: "30px",
            }}
          >
            <div>*</div>
            <div
              style={{
                margin: "0 20px 0 0px",
                width: "40px",
                textAlign: "center",
              }}
            >
              描述
            </div>

            <TextArea
              rows={4}
              value={this.state.value2}
              onChange={(e) => this.descChange(e)}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "30px",
              marginLeft: "30px",
            }}
          >
            <div>*</div>
            <div
              style={{
                margin: "0 20px 0 0",
                width: "40px",
                textAlign: "center",
              }}
            >
              封面
            </div>
            <div>
              <div style={{ width: "200px", height: "150px" }}>
                <img
                  style={{ width: "200px", height: "150px" }}
                  src={this.props.coverPic}
                  alt=""
                />
              </div>
              <div style={{ marginTop: "10px" }}>
                <Radio.Group
                  onChange={this.radioChange}
                  value={this.state.radioValue}
                  size="large"
                >
                  <Radio value={1}>封面小图显示</Radio>
                  <Radio value={2}>封面大图显示</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>

          <div
            style={{ display: "flex", alignItems: "center", marginTop: "30px" }}
          >
            <div>*</div>
            <div
              style={{
                margin: "0 20px 0 0",
                width: "80px",
                textAlign: "center",
              }}
            >
              选择栏目
            </div>

            <TreeSelect
              style={{ width: "100%" }}
              value={this.state.value3}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              treeData={treeData}
              showCheckedStrategy={SHOW_PARENT}
              treeDefaultExpandAll
              treeCheckable={true}
              onChange={(value) => {
                this.state.value3 = value;
                this.setState({});
              }}
            />
          </div>
          <div
            style={{
              marginLeft: "15px",
              marginTop: "30px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ marginRight: "9px" }}>发布账号</div>
            <div style={{ margin: "0 20px" }}>
              <TreeSelect
                dropdownStyle={{ height: "100px" }}
                style={{ width: "200px" }}
                placeholder="请选择账号类型"
                value={this.state.value4}
                onChange={(value) => {
                  this.state.value4 = value;
                  this.setState({});

                  if (value === "单位发布") {
                    this.props.getEditorColumnLists();
                  } else if (value === "个人发布") {
                    this.props.getAllReports();
                  }
                }}
              >
                <TreeNode
                  value="请选择账号类型"
                  title="请选择账号类型"
                  key="0-1"
                />
                <TreeNode
                  value="单位发布"
                  title="单位发布"
                  key="0-2"
                />
                <TreeNode
                  value="个人发布"
                  title="个人发布"
                  key="0-3"
                />
              </TreeSelect>
            </div>
            <div>
              <TreeSelect
                dropdownStyle={{ height: "100px" }}
                style={{ width: "200px" }}
                placeholder="请选择账号"
                value={this.state.accountKey}
                treeData={
                  this.state.value4 === "单位发布"
                    ? this.props.editorColumnList
                    : this.state.value4 === "个人发布"
                      ? treeData3
                      : null
                }
                onChange={(value) => {
                  this.state.accountKey = value;
                  this.setState({});
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button onClick={this.store}>存为草稿</Button>
            <div style={{ marginLeft: "10px" }}>
              <Button type="primary">发布</Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  // 点击删除
  delete = (index) => {
    let dataList = this.state.dataList;
    dataList.splice(index, 1);
    this.setState({
      dataList,
    });
  };
  // 点击存为草稿
  store = () => {
    this.props.myAlter && this.props.myAlter(this.state.value2);
  };
  radioChange = (e) => {
    this.setState({
      radioValue: e.target.value,
    });
  };
  descChange = (e) => {
    this.setState({
      value2: e.target.value,
    });
  };
}
